// File: src/hooks/Auth/useSignout.ts
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { signOut } from '../../redux/auth/authSlice';
import { RootState } from '../../redux/'; // Import RootState type

export const useSignOut = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state: RootState) => state.auth);

  const handleSignOut = useCallback(async () => {
    try {
      // Use type assertion to handle dispatch properly
      await dispatch(signOut() as any).unwrap();
      // Optional: Add any post-signout logic here
      return true;
    } catch (err) {
      console.error('Sign out error:', err);
      return false;
    }
  }, [dispatch]);

  return {
    handleSignOut,
    isLoading: loading,
    error
  };
};